export default __webpack_public_path__ + "static/media/bt4DG1mobile.5e506c6c.png";